import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-产品动画",
  "use": "icon-产品动画-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-产品动画\">\n    <title>icon/10pt/产品动画</title>\n    <g id=\"icon-产品动画_icon/10pt/产品动画\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M48.1666667,87.25 C69.7056784,87.25 87.1666667,69.7890118 87.1666667,48.25 C87.1666667,26.7109882 69.7056784,9.25 48.1666667,9.25 C26.6276549,9.25 9.16666667,26.7109882 9.16666667,48.25 C9.16666667,69.7890118 26.6276549,87.25 48.1666667,87.25 Z\" id=\"icon-产品动画_路径备份\" stroke=\"#333333\" stroke-width=\"6\" stroke-linejoin=\"round\" />\n        <polygon id=\"icon-产品动画_路径-3备份\" fill=\"#2C2C2E\" transform=\"translate(52.500000, 48.563195) rotate(-90.000000) translate(-52.500000, -48.563195) \" points=\"52.5 61.0631951 73.7335693 36.0631951 31.2664307 36.0631951\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/产品动画.svg
// module id = 011+
// module chunks = 2